import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {withRouter} from 'react-router-dom';

import ErrorPanelView, {IMAGES} from '@stubhub/react-error-panel-core';

import {defaultMessages, genericMessages} from './messages';

const ErrorPanel = ({
  className,
  buttonText: propButtonText,
  header: propHeader,
  history,
  onCtaClick,
  paragraph: propParagraph,
  redirectUrl,
  shouldRefresh,
  statusCode,
  subheader: propSubheader,
  image,
  secondaryButtonText,
  secondaryClickHandler,
}) => {
  const header = propHeader ?? <FormattedMessage {...defaultMessages.header} />;
  const subheader = propSubheader ?? <FormattedMessage {...defaultMessages.subheader} />;
  const paragraph = propParagraph ?? (
    <FormattedMessage
      {...defaultMessages.paragraph}
      values={{
        linebreak: <br />,
        errorType: statusCode ? (
          <>
            <br />
            <FormattedMessage {...genericMessages.error} values={{errorCode: statusCode}} />
          </>
        ) : (
          ''
        ),
      }}
    />
  );
  const buttonText =
    propButtonText ??
    (shouldRefresh ? (
      <FormattedMessage {...defaultMessages.buttonRefresh} />
    ) : redirectUrl ? (
      <FormattedMessage {...defaultMessages.buttonRedirect} />
    ) : (
      ''
    ));

  const clickHandler = (e) => {
    if (shouldRefresh) {
      history.go(0);
    } else if (redirectUrl) {
      history.push(redirectUrl);
    } else if (onCtaClick) {
      onCtaClick(e);
    }
  };

  return (
    <ErrorPanelView
      className={className}
      header={header}
      subheader={subheader}
      paragraph={paragraph}
      buttonText={buttonText}
      clickHandler={clickHandler}
      image={image}
      secondaryButtonText={secondaryButtonText}
      secondaryClickHandler={secondaryClickHandler}
    />
  );
};

ErrorPanel.propTypes = {
  className: PropTypes.string,
  buttonText: PropTypes.string,
  header: PropTypes.node,
  history: PropTypes.object,
  onCtaClick: PropTypes.func,
  paragraph: PropTypes.node,
  redirectUrl: PropTypes.string,
  shouldRefresh: PropTypes.bool,
  statusCode: PropTypes.string,
  subheader: PropTypes.node,
  image: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  secondaryClickHandler: PropTypes.func,
};

export default withRouter(ErrorPanel);
export {ErrorPanel, IMAGES};
